import React from 'react';
import PropTypes from 'prop-types';

import { PORCELAIN, OSLO_GRAY } from '@constant/colors';

const Next = ({ className, onClick }) => (
  <svg className={className} viewBox="0 0 32 32" onClick={onClick}>
    <g fill="none" fillRule="evenodd">
      <rect width="100%" height="100%" fill={PORCELAIN} rx="50%" />
      <path
        fill={OSLO_GRAY}
        d="M18.885 10.814l-1.57-1.57-7.072 7.07 7.07 7.07 1.572-1.57-5.5-5.5 5.5-5.5z"
      />
    </g>
  </svg>
);

Next.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default Next;
